import React, { useState } from 'react';
import proService, { ProParticipant } from '../../services/proService';

/**
 * Spieler-Avatar mit Initialen-Fallback.
 * Defensiv: fehlende/kaputte Bilder fallen automatisch auf Initialen zurück.
 */
const PlayerAvatar: React.FC<{
  participant?: ProParticipant;
  size?: 'sm' | 'md';
}> = ({ participant, size = 'sm' }) => {
  const [imgFailed, setImgFailed] = useState(false);
  const image = proService.getParticipantImage(participant);
  const initials = proService.getParticipantInitials(participant);
  const sizeCls = size === 'md' ? 'w-9 h-9 text-[11px]' : 'w-7 h-7 text-[10px]';

  return (
    <div
      className={`${sizeCls} rounded-full bg-zinc-800 border border-zinc-700/60 flex items-center justify-center overflow-hidden flex-shrink-0`}
    >
      {image && !imgFailed ? (
        <img
          src={image}
          alt=""
          loading="lazy"
          className="w-full h-full object-cover"
          onError={() => setImgFailed(true)}
        />
      ) : (
        <span className="font-semibold text-gray-400 leading-none select-none">
          {initials}
        </span>
      )}
    </div>
  );
};

export default PlayerAvatar;
